import { createSelector } from 'reselect';
import userSelector from './user';

const DEFAULT = {
  folders: {},
  components: {},
  reports: {}
};

export default createSelector(userSelector, user => user.permissions || DEFAULT);
